function getBoxPosition(mstarRating, mstarSenitvityRating) {
  let val = 318;
  if (mstarRating === 'low') {
    switch (mstarSenitvityRating) {
      case 'limited':
        val = 240;
        break;
      case 'moderate':
        val = 160;
        break;
      case 'extensive':
        val = 80;
        break;
      default:
    }
  }
  if (mstarRating === 'medium') {
    switch (mstarSenitvityRating) {
      case 'limited':
        val = 476;
        break;
      case 'moderate':
        val = 398;
        break;
      case 'extensive':
        val = 318;
        break;
      default:
    }
  }
  if (mstarRating === 'high') {
    switch (mstarSenitvityRating) {
      case 'limited':
        val = 714;
        break;
      case 'moderate':
        val = 634;
        break;
      case 'extensive':
        val = 556;
        break;
      default:
    }
  }
  return `${val}px 0px`;
}

const mutations = {
  SET_MSTAR_STYLE_BOX(state, payload) {
    state.mstarFixedIncome.MstarRating = payload.mstarRating;
    state.mstarFixedIncome.MstarSenitvityRating = payload.mstarSenitvityRating;
    state.mstarFixedIncome.AsOfDate = `${payload.asOfDate} `;
    state.mstarFixedIncome.boxPosition = getBoxPosition(payload.mstarRating.toLowerCase(), payload.mstarSenitvityRating.toLowerCase());
  }
};
const getters = {
  getMstarStyleBox: state => state.mstarFixedIncome
};

const state = {
  mstarFixedIncome: {
    MstarRating: '',
    MstarSenitvityRating: '',
    AsOfDate: '',
    boxPosition: '',
    labelUrl: require('_assets_/img/Interest_Rate_Sensitivity_Labels.png'),
    styleBoxUrl: require('_assets_/img/style_box_sprite.png')
  }
};

export default {
  state,
  getters,
  mutations
};
